(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-article-banner"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.mfg-banner__share').forEach(function (btn) {
  var label = btn.querySelector('span');

  function notify(message) {
    if (!label) return;
    if (!btn.dataset.originalLabel) btn.dataset.originalLabel = label.textContent;
    label.textContent = message;
    clearTimeout(btn._resetTimer);
    btn._resetTimer = setTimeout(function () {
      label.textContent = btn.dataset.originalLabel;
    }, 2000);
  }

  function legacyCopy(text) {
    try {
      var ta = document.createElement('textarea');
      ta.value = text;
      ta.setAttribute('readonly', '');
      ta.style.position = 'absolute';
      ta.style.left = '-9999px';
      document.body.appendChild(ta);
      ta.select();
      var ok = document.execCommand('copy');
      document.body.removeChild(ta);
      return ok;
    } catch (e) {
      return false;
    }
  }

  btn.addEventListener('click', async function () {
    var url = btn.dataset.shareUrl;
    var title = btn.dataset.shareTitle;

    if (navigator.share) {
      try {
        await navigator.share({ title: title, url: url });
        return;
      } catch (e) {
        // User cancelled the native sheet — do nothing further.
        if (e && e.name === 'AbortError') return;
      }
    }

    var copied = false;
    if (navigator.clipboard && navigator.clipboard.writeText) {
      try {
        await navigator.clipboard.writeText(url);
        copied = true;
      } catch (e) {}
    }
    if (!copied) copied = legacyCopy(url);

    notify(copied ? 'Link copied' : 'Press Ctrl/Cmd + C');
  });
});

document.querySelectorAll('.mfg-banner__scroll').forEach(function (cue) {
  cue.addEventListener('click', function () {
    var banner = cue.closest('.mfg-banner');
    var wrapper = banner ? banner.closest('.shopify-section') : null;
    var next = wrapper ? wrapper.nextElementSibling : null;
    var target = next || banner;
    if (target) {
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"] && !Shopify.designMode) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class FooterMenu extends DetailsDisclosure {
      constructor() {
        super();
        this.reset(false);
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        const isConfirmNewsletter = !isLargeScreen &&
          (window.location.hash === '#footer-signup_form' && this.querySelector('#footer-signup_form') !== null);

        if (!this.disclosure) return;

        this.disclosure.open = isLargeScreen || isConfirmNewsletter;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }
    }

    customElements.define('footer-menu', FooterMenu);
  });

  function openLiveChat() {
    const iframe = document.getElementById('chat-button');
    if (!iframe) return;

    const doc = iframe.contentDocument || iframe.contentWindow?.document;
    if (!doc) return;

    doc.querySelector('button')?.click();
  }

  function initFooterLiveChat() {
    if (!document.querySelector('.live-chat-btn')) return;

    document.addEventListener('click', (event) => {
      const liveChatBtn = event.target.closest('.live-chat-btn');
      if (!liveChatBtn) return;

      event.preventDefault();
      openLiveChat();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initFooterLiveChat);
  } else {
    initFooterLiveChat();
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class NavMenu extends DetailsDisclosure {
      constructor() {
        super();

        if(this.matches('.js-mega-nav')) {
          this.reset(false);
          window.addEventListener('on:breakpoint-change', this.reset.bind(this));
        }
      }

      reset(resize = true) {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.nav).matches;
        this.disclosure.open = isLargeScreen;
        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }

      handleToggle(e) {
        if (!(this.matches('.js-mega-nav') && window.matchMedia(theme.mediaQueries.nav).matches)) {
          super.handleToggle(e);
        }
      }
    }

    customElements.define('nav-menu', NavMenu);
  });

  /* ------------------------------------------------------------------ */
  /* Mobile-only: search bar toggle                                     */
  /* Toggles .mobile-search-open on <store-header>, syncs aria-expanded */
  /* on the button, focuses the search input on open, and closes on    */
  /* Escape or outside-tap.                                             */
  /* ------------------------------------------------------------------ */
  (function initMobileSearchToggle() {
    const init = () => {
      const storeHeader = document.querySelector('store-header');
      if (!storeHeader) return;

      const toggles = storeHeader.querySelectorAll('.js-mobile-search-toggle');
      if (!toggles.length) return;

      const searchBar = storeHeader.querySelector('#search-bar');
      if (!searchBar) return;
      const searchInput = searchBar.querySelector('input[name="q"]');

      // The bar sits before the toggle in reading order, so focus has to
      // follow it or screen-reader users never find the field. Focus is set
      // synchronously so iOS still raises the keyboard inside the tap.
      const setOpen = (isOpen, trigger) => {
        storeHeader.classList.toggle('mobile-search-open', isOpen);
        toggles.forEach((btn) => btn.setAttribute('aria-expanded', String(isOpen)));
        if (isOpen) searchInput?.focus({ preventScroll: true });
        else if (trigger && searchBar.contains(document.activeElement)) trigger.focus();
      };

      // ONLY the eyeglass button toggles the bar. No auto-close on
      // outside click, no auto-close on Escape.
      // The user explicitly closes by pressing the eyeglass again.
      toggles.forEach((btn) => {
        btn.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          setOpen(!storeHeader.classList.contains('mobile-search-open'), btn);
        });
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init, { once: true });
    } else {
      init();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-login"]) return;
  try {
    
  if (!customElements.get('password-reveal')) {
    class PasswordReveal extends HTMLElement {
      connectedCallback() {
        this.input = this.querySelector('input');
        this.button = this.querySelector('[data-password-toggle]');
        if (!this.input || !this.button) return;
        this.showLabel = this.dataset.showLabel || 'Show';
        this.hideLabel = this.dataset.hideLabel || 'Hide';
        this.button.addEventListener('click', this.toggle.bind(this));
      }

      toggle() {
        const shown = this.input.getAttribute('type') === 'text';
        this.input.setAttribute('type', shown ? 'password' : 'text');
        this.button.setAttribute('aria-pressed', shown ? 'false' : 'true');
        this.button.textContent = shown ? this.showLabel : this.hideLabel;
      }
    }

    customElements.define('password-reveal', PasswordReveal);
  }

  if (!customElements.get('login-page')) {
    class LoginPage extends HTMLElement {
      connectedCallback() {
        this.loginPanel = this.querySelector('#login');
        this.recoverPanel = this.querySelector('#recover');
        this.recoverLink = this.querySelector('.js-recover');
        this.loginLink = this.querySelector('.js-login');

        this.onRecover = this.onRecover.bind(this);
        this.onLogin = this.onLogin.bind(this);

        if (this.recoverLink) this.recoverLink.addEventListener('click', this.onRecover);
        if (this.loginLink) this.loginLink.addEventListener('click', this.onLogin);

        this.querySelectorAll('.js-shop-login').forEach((btn) => {
          btn.addEventListener('click', () => {
            const shopBtn = this.querySelector(
              'shop-login-button, .shop-login-button, [data-shop-login-button]'
            );
            this.oxiLog('shop button clicked, native button found:', shopBtn ? 'yes' : 'no');
            if (shopBtn) shopBtn.click();
          });
        });

        this.dropDuplicateOxiWidget();

        this.onOxiMessage = this.onOxiMessage.bind(this);
        window.addEventListener('message', this.onOxiMessage);

        this.initOxiDebug();
        this.oxiLog('page load', window.location.pathname + window.location.search);

        if (window.location.hash === '#recover' || this.querySelector('.login-page__recover-success')) {
          this.toggleRecover(true);
        }
      }

      disconnectedCallback() {
        if (this.recoverLink) this.recoverLink.removeEventListener('click', this.onRecover);
        if (this.loginLink) this.loginLink.removeEventListener('click', this.onLogin);
        window.removeEventListener('message', this.onOxiMessage);
        if (this.oxiDuplicateObserver) this.oxiDuplicateObserver.disconnect();
      }

      // Stays on once enabled, because the handoff drops the query string on
      // the page we land on — which is exactly where the trace is needed.
      get oxiDebugEnabled() {
        if (/[?&]oxidebug=(1|reset)/.test(window.location.search)) return true;
        return this.oxiDebugEntries().length > 0;
      }

      oxiDebugEntries() {
        try {
          return JSON.parse(sessionStorage.getItem('oxi-debug-log') || '[]');
        } catch (err) {
          return [];
        }
      }

      // The handoff navigates away, so the trace has to outlive the page. It
      // accumulates for the whole session and is shown on the page, because
      // the console is cleared on navigation and storage is awkward to read
      // mid-flow. Reset with ?oxidebug=reset.
      oxiLog() {
        if (!this.oxiDebugEnabled) return;
        const parts = Array.prototype.slice.call(arguments);
        console.log.apply(console, ['[oxi]'].concat(parts));
        try {
          const entries = this.oxiDebugEntries();
          entries.push(new Date().toISOString().slice(11, 19) + ' ' + parts.join(' '));
          sessionStorage.setItem('oxi-debug-log', JSON.stringify(entries.slice(-60)));
        } catch (err) {
          /* storage unavailable */
        }
        this.renderOxiDebug();
      }

      initOxiDebug() {
        if (!this.oxiDebugEnabled) return;
        if (/[?&]oxidebug=reset/.test(window.location.search)) {
          try {
            sessionStorage.removeItem('oxi-debug-log');
          } catch (err) {
            /* storage unavailable */
          }
        }
        const entries = this.oxiDebugEntries();
        if (entries.length) console.log('[oxi] trace so far:\n' + entries.join('\n'));
        this.renderOxiDebug();
      }

      renderOxiDebug() {
        if (!this.oxiDebugEnabled) return;
        if (!this.oxiDebugPanel) {
          this.oxiDebugPanel = document.createElement('pre');
          this.oxiDebugPanel.className = 'login-page__oxi-debug';
          this.oxiDebugPanel.setAttribute('aria-hidden', 'true');
          document.body.appendChild(this.oxiDebugPanel);
        }
        const entries = this.oxiDebugEntries();
        this.oxiDebugPanel.textContent =
          'oxi trace (' + entries.length + ')\n' + (entries.length ? entries.join('\n') : 'nothing logged yet');
      }

      // Oxi's automatic placement adds a second widget carrying a duplicate
      // #social_login_frame id. Its resize logic reads that id and sizes the
      // wrong frame once, leaving ours stuck at a default height, so the
      // duplicate has to be gone rather than merely hidden.
      dropDuplicateOxiWidget() {
        const strip = () => {
          this.querySelectorAll('.oxi_social_wrapper').forEach((el) => el.remove());
        };
        strip();
        this.oxiDuplicateObserver = new MutationObserver(strip);
        this.oxiDuplicateObserver.observe(this, { childList: true, subtree: true });
      }

      // Observation only. Oxi's app-embed script handles these same messages
      // and performs the navigation; acting on them here would double up.
      onOxiMessage(event) {
        if (event.origin !== 'https://social-login.oxiapps.com') {
          if (event.origin && event.origin.indexOf('oxi') !== -1) this.oxiLog('ignored origin', event.origin);
          return;
        }
        let data = event.data;
        if (data === 'oxiSocialLoginTrigger' || data === 'oxiSocialLoginSuccess') {
          this.oxiLog('notice', data);
          return;
        }
        if (typeof data === 'string') {
          try {
            data = JSON.parse(data);
          } catch (err) {
            this.oxiLog('unparsed string payload');
            return;
          }
        }
        if (!data || !data.action) {
          this.oxiLog('payload with no action, keys:', data ? Object.keys(data).join(',') : String(data));
          return;
        }
        this.oxiLog('action', data.action);
      }

      onRecover(evt) {
        evt.preventDefault();
        this.toggleRecover(true);
        history.pushState('', document.title, `${window.location.pathname}${window.location.search}#recover`);
      }

      onLogin(evt) {
        evt.preventDefault();
        this.toggleRecover(false);
        history.pushState('', document.title, `${window.location.pathname}${window.location.search}`);
      }

      toggleRecover(recover) {
        if (!this.loginPanel || !this.recoverPanel) return;
        this.loginPanel.classList.toggle('is-hidden', recover);
        this.recoverPanel.classList.toggle('is-open', recover);
        const focusTarget = recover
          ? this.recoverPanel.querySelector('.alert, input')
          : this.loginPanel.querySelector('.alert, input');
        if (focusTarget) focusTarget.focus();
      }
    }

    customElements.define('login-page', LoginPage);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["track-order-test"] && !Shopify.designMode) return;
  try {
    
class TrackOrderTest extends HTMLElement {
  connectedCallback() {
    this.shop = this.dataset.shop;
    this.form = this.querySelector('[data-tot-form]');
    this.result = this.querySelector('[data-tot-result]');
    this.mode = 'order';
    this.replaceKeywords = this.dataset.replaceKeywords === 'true';
    this.replacement = this.dataset.replacement || 'test';
    this.keywords = (this.dataset.keywords || '')
      .split(',').map((k) => k.trim()).filter(Boolean);
    this._keywordRe = this.keywords.length
      ? new RegExp('(' + this.keywords.map(this._escape).join('|') + ')', 'gi')
      : null;

    this.fallback = this.dataset.fallback || '/apps/17TRACK';
    this.fromName = this.dataset.fromName || 'Residence Supply';
    this.fromCity = this.dataset.fromCity || '';
    this.fromCountry = this.dataset.fromCountry || '';
    this.supportEmail = this.dataset.supportEmail || '';

    // Origin suppression: hide foreign-origin locations from buyers (dropshipping).
    this.hideOrigin = this.dataset.hideOrigin !== 'false';
    const originTokens = (this.dataset.originTokens || '')
      .split(',').map((t) => t.trim()).filter(Boolean);
    const latin = originTokens.filter((t) => /^[\x00-\x7F]+$/.test(t)).map(this._escape);
    this._originLatinRe = latin.length ? new RegExp('\\b(' + latin.join('|') + ')\\b', 'i') : null;
    this._originCJK = originTokens.filter((t) => !/^[\x00-\x7F]+$/.test(t));

    // Consumer carriers we may name + link to. Anything else (dropship lines,
    // CN-based forwarders) is shown generically so we never reveal the origin.
    this._carrierAllow = /\b(UPS|FedEx|USPS|DHL|Canada Post|Royal Mail|Australia Post|Purolator|DPD|GLS|Evri|Poste|La Poste|PostNL|An Post|TNT)\b/i;

    // Customer-facing English derived from 17TRACK's normalized sub_status codes.
    this.SUBSTATUS = {
      InfoReceived: 'Order information received',
      InTransit: 'In transit',
      InTransit_PickedUp: 'Picked up by carrier',
      InTransit_Departure: 'Departed facility',
      InTransit_Arrival: 'Arrived at facility',
      InTransit_CustomsProcessing: 'Processing through customs',
      InTransit_CustomsReleased: 'Released from customs',
      InTransit_CustomsRequiringInformation: 'Customs information required',
      InTransit_TransportArrived: 'Arrived at facility',
      InTransit_TransportDeparted: 'Departed facility',
      InTransit_Other: 'In transit',
      Expired: 'Tracking expired',
      AvailableForPickup: 'Available for pickup',
      AvailableForPickup_Other: 'Available for pickup',
      OutForDelivery: 'Out for delivery',
      OutForDelivery_Other: 'Out for delivery',
      DeliveryFailure: 'Delivery attempted',
      DeliveryFailure_Other: 'Delivery attempted',
      Delivered: 'Delivered',
      Delivered_Other: 'Delivered',
      Exception: 'Delivery exception',
      Exception_Other: 'Delivery exception',
      Exception_Returning: 'Being returned to sender',
      Exception_Returned: 'Returned to sender',
      NotFound: 'Awaiting carrier update',
    };

    // status -> hero badge + pill category + 0-based stepper position (6 steps)
    this.STATUS_PILL = {
      InfoReceived: 'grey', InTransit: 'blue', AvailableForPickup: 'blue',
      OutForDelivery: 'amber', DeliveryFailure: 'amber', Delivered: 'green',
      Exception: 'red', Expired: 'grey', NotFound: 'grey',
    };

    this.COUNTRIES = {
      US: 'United States', CA: 'Canada', GB: 'United Kingdom', AU: 'Australia',
      NZ: 'New Zealand', IE: 'Ireland', CH: 'Switzerland', DE: 'Germany',
      FR: 'France', IT: 'Italy', ES: 'Spain', PT: 'Portugal', NL: 'Netherlands',
      BE: 'Belgium', AT: 'Austria', SE: 'Sweden', NO: 'Norway', DK: 'Denmark',
      FI: 'Finland', PL: 'Poland', CZ: 'Czechia', JP: 'Japan', KR: 'South Korea',
      SG: 'Singapore', AE: 'United Arab Emirates', MX: 'Mexico', BR: 'Brazil',
    };

    this.querySelectorAll('.tot__tab').forEach((tab) => {
      tab.addEventListener('click', () => this._switchTab(tab.dataset.tab));
    });
    this.form.addEventListener('submit', (e) => {
      e.preventDefault();
      this._track();
    });
    // delegated actions in rendered result (copy / track-another)
    this.result.addEventListener('click', (e) => {
      const copy = e.target.closest('[data-copy]');
      if (copy) return this._copy(copy);
      const back = e.target.closest('[data-back]');
      if (back) { e.preventDefault(); this._reset(); }
    });

    // Auto-load when arriving from an order link (?tn= or ?on=&em=).
    this._autoload();
  }

  // Prefill + submit from URL params so order links land on a loaded result.
  _autoload() {
    let params;
    try { params = new URLSearchParams(window.location.search); } catch (e) { return; }
    const tn = (params.get('tn') || '').trim();
    const on = (params.get('on') || '').trim();
    const em = (params.get('em') || '').trim();
    if (tn) {
      this._switchTab('track');
      const input = this.form.querySelector('[name="track_no"]');
      if (input) input.value = tn;
      this._track();
    } else if (on && em) {
      this._switchTab('order');
      const oi = this.form.querySelector('[name="order_no"]');
      const ei = this.form.querySelector('[name="user_email"]');
      if (oi) oi.value = on;
      if (ei) ei.value = em;
      this._track();
    } else if (on) {
      this._switchTab('order');
      const oi = this.form.querySelector('[name="order_no"]');
      if (oi) oi.value = on;
      const ei = this.form.querySelector('[name="user_email"]');
      if (ei) ei.focus();
    }
  }

  _escape(s) { return s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); }

  _switchTab(mode) {
    this.mode = mode;
    this.querySelectorAll('.tot__tab').forEach((t) => {
      const active = t.dataset.tab === mode;
      t.classList.toggle('is-active', active);
      t.setAttribute('aria-selected', active ? 'true' : 'false');
    });
    this.querySelectorAll('[data-panel]').forEach((p) => {
      p.classList.toggle('is-hidden', p.dataset.panel !== mode);
    });
  }

  _reset() {
    this.result.replaceChildren();
    this.form.scrollIntoView({ behavior: 'smooth', block: 'center' });
    const first = this.form.querySelector('.tot__input');
    if (first) first.focus();
  }

  _copy(btn) {
    const val = btn.getAttribute('data-copy');
    const done = () => {
      const prev = btn.textContent;
      btn.textContent = 'Copied';
      btn.classList.add('is-copied');
      setTimeout(() => { btn.textContent = prev; btn.classList.remove('is-copied'); }, 1600);
    };
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(val).then(done, () => {});
    }
  }

  // Replace origin keywords with the test marker so we can see our transform run.
  _clean(text) {
    if (!text) return text;
    if (this.replaceKeywords && this._keywordRe) {
      return String(text).replace(this._keywordRe, this.replacement);
    }
    return text;
  }

  async _api(host, body) {
    const res = await fetch('https://' + host, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body),
    });
    if (!res.ok) throw new Error('HTTP ' + res.status);
    return res.json();
  }

  // The feed returns empty (HTTP 200) under transient throttling. Retry on empty.
  async _apiTry(host, body, ok, tries) {
    let last = null;
    for (let i = 0; i < tries; i++) {
      try { last = await this._api(host, body); } catch (e) { last = null; }
      if (last && ok(last)) return last;
      if (i + 1 < tries) await new Promise((r) => setTimeout(r, 500 * (i + 1)));
    }
    return last;
  }

  async _track() {
    const fd = new FormData(this.form);
    const tz = new Date().getTimezoneOffset();
    let recordReq;
    if (this.mode === 'order') {
      const order_no = (fd.get('order_no') || '').trim();
      const user_email = (fd.get('user_email') || '').trim();
      if (!order_no || !user_email) return this._error('Enter your order number and email.');
      recordReq = { type: 'order', order_no, user_email };
    } else {
      const track_no = (fd.get('track_no') || '').trim();
      if (!track_no) return this._error('Enter your tracking number.');
      recordReq = { type: 'track', track_no };
    }

    this._loading();
    try {
      const method = this.mode === 'order'
        ? 'get-track-record-by-order-no'
        : 'get-track-record-by-track-no';
      const rec = await this._apiTry('shopify.17track.net/trackcenterapi/call', {
        Version: '1.0', Method: method, SourceType: '0', Cookies: '', TimeZoneOffset: tz,
        Param: Object.assign({ shop: this.shop }, recordReq),
      }, (r) => r && r.Json && r.Json.info && r.Json.info.no, 3);
      const info = rec && rec.Json && rec.Json.info;
      if (!info || !info.no) {
        const tip = this.mode === 'track'
          ? ' Try looking up by order number and email instead.'
          : ' Double-check your order number and the email used at checkout.';
        return this._error('We couldn’t find a shipment for that.' + tip);
      }
      const carrier = info.carrier_info && info.carrier_info.first_carrier_info;
      if (!carrier || !info.fc) {
        return this._render(info, null);
      }
      const detail = await this._apiTry('shopify-t.17track.net/track/shopify', {
        data: [{ num: info.no, fc: info.fc, sc: info.sc || 0, params: {} }],
        g: info.g, lang: 'en', timeZoneOffset: tz,
      }, (r) => r && r.shipments && r.shipments[0] && r.shipments[0].shipment, 3);
      const shipment = detail && detail.shipments && detail.shipments[0] && detail.shipments[0].shipment;
      this._render(info, shipment);
    } catch (err) {
      this._error('Something went wrong fetching your tracking. Please try again.');
    }
  }

  _loading() {
    this.result.innerHTML = '<div class="tot__loading">Looking up your shipment…</div>';
  }

  _error(msg) {
    const tpl = this.querySelector('[data-tpl="error"]');
    const node = tpl.content.cloneNode(true);
    if (msg) node.querySelector('[data-slot="msg"]').textContent = msg;
    this.result.replaceChildren(node);
  }

  /* ---------- date helpers ---------- */
  _date(iso) { try { return iso ? new Date(iso) : null; } catch (e) { return null; } }
  _fmtFull(iso) {
    const d = this._date(iso); if (!d) return '';
    return d.toLocaleDateString(undefined, { month: 'short', day: 'numeric', year: 'numeric' })
      + '  ·  ' + d.toLocaleTimeString(undefined, { hour: 'numeric', minute: '2-digit' });
  }
  _fmtStep(iso) {
    const d = this._date(iso); if (!d) return '';
    return d.toLocaleDateString(undefined, { month: 'short', day: 'numeric' })
      + ' · ' + d.toLocaleTimeString(undefined, { hour: 'numeric', minute: '2-digit' });
  }
  _fmtDay(iso) {
    const d = this._date(iso); if (!d) return '';
    return d.toLocaleDateString(undefined, { weekday: 'long', month: 'short', day: 'numeric' });
  }
  _fmtDayShort(iso) {
    const d = this._date(iso); if (!d) return '';
    return d.toLocaleDateString(undefined, { month: 'short', day: 'numeric' });
  }
  _fmtTime(iso) {
    const d = this._date(iso); if (!d) return '';
    return d.toLocaleTimeString(undefined, { hour: 'numeric', minute: '2-digit' });
  }

  /* ---------- normalization ---------- */
  _hasCJK(s) {
    return /[\u3400-\u9FFF\uF900-\uFAFF\u3000-\u303F\uFF00-\uFFEF]/.test(String(s));
  }
  _describe(ev) {
    const raw = ev.description ? String(ev.description).trim() : '';
    if (raw && !this._hasCJK(raw)) return this._clean(raw);
    const code = ev.sub_status || ev.stage || '';
    const prefix = String(code).split('_')[0];
    return this.SUBSTATUS[code] || this.SUBSTATUS[prefix] || 'Tracking update';
  }
  _isOrigin(text) {
    if (!this.hideOrigin || !text) return false;
    if (this._originLatinRe && this._originLatinRe.test(text)) return true;
    return this._originCJK.some((t) => text.indexOf(t) > -1);
  }
  _place(ev) {
    const a = ev.address || {};
    const parts = [...new Set([a.city, a.state, a.country].filter((p) => p && !this._hasCJK(p)))];
    let text = parts.join(', ');
    if (!text) {
      const loc = ev.location ? String(ev.location).trim() : '';
      if (loc && !this._hasCJK(loc)) text = loc;
    }
    if (!text || this._isOrigin(text)) return '';
    return this._clean(text);
  }

  /* ---------- derived display ---------- */
  _statusLabel(s) {
    const map = {
      InfoReceived: 'Order received', InTransit: 'In transit', Expired: 'Delayed',
      AvailableForPickup: 'Ready for pickup', OutForDelivery: 'Out for delivery',
      DeliveryFailure: 'Delivery attempted', Delivered: 'Delivered',
      Exception: 'Exception', NotFound: 'In progress',
    };
    return map[s] || s || 'In progress';
  }
  _pill(ev) {
    const code = ev.sub_status || ev.stage || '';
    const prefix = String(code).split('_')[0];
    const labels = {
      InfoReceived: 'Info received', InTransit: 'In transit', PickedUp: 'Picked up',
      Arrival: 'Arrived', Departure: 'In transit', AvailableForPickup: 'Available for pickup',
      OutForDelivery: 'Out for delivery', DeliveryFailure: 'Delivery attempted',
      Delivered: 'Delivered', Exception: 'Exception', Expired: 'Expired', NotFound: 'Pending',
    };
    const cat = this.STATUS_PILL[prefix] || 'grey';
    return { cat: cat, label: labels[prefix] || 'Update' };
  }
  _country(code) {
    if (!code) return '';
    return this.COUNTRIES[code] || code;
  }
  _milestoneTime(shipment, key) {
    const ms = (shipment && shipment.milestone) || [];
    const m = ms.find((x) => x.key_stage === key && x.time_iso);
    return m ? m.time_iso : null;
  }
  _carrier(info) {
    const ci = info.carrier_info && info.carrier_info.first_carrier_info;
    if (!ci) return { name: 'Standard shipping', url: null };
    const allow = this._carrierAllow.test(ci.name || '') && ci.country !== 'CN';
    if (allow) return { name: ci.name, url: ci.tracking_url || ci.url || null };
    return { name: 'Standard shipping', url: null };
  }
  // Shopify returns an internal fulfillment placeholder (e.g.
  // "vpShipped-fulfillmentId-123") when there is no real carrier tracking
  // number yet. Never surface those to the buyer.
  _isPlaceholderNo(no) {
    if (!no) return true;
    return /fulfillment|^vp[a-z0-9]*-/i.test(String(no).trim());
  }
  _heroTitle(status, shipment) {
    if (status === 'Delivered') {
      const t = this._milestoneTime(shipment, 'Delivered') || (shipment && shipment.latest_event && shipment.latest_event.time_iso);
      return t ? 'Delivered ' + this._fmtDay(t) : 'Delivered';
    }
    const edd = shipment && shipment.time_metrics && shipment.time_metrics.estimated_delivery_date;
    if (edd && (edd.to || edd.from)) return 'Arriving ' + this._fmtDay(edd.to || edd.from);
    const phrase = {
      InTransit: 'On its way', OutForDelivery: 'Out for delivery today',
      AvailableForPickup: 'Ready for pickup', Exception: 'Delivery exception',
      Expired: 'Tracking delayed', DeliveryFailure: 'Delivery attempted',
      InfoReceived: 'Order received', NotFound: 'In progress',
    };
    return phrase[status] || 'On its way';
  }
  _heroSub(status, shipment) {
    if (!shipment) return 'We’ll show scan details here as your package moves.';
    const le = shipment.latest_event;
    if (status === 'Delivered') {
      const place = le ? this._place(le) : '';
      return 'Your order has arrived' + (place ? ' in ' + place : '') + '.';
    }
    if (!le) return 'Your package is on its way.';
    const place = this._place(le);
    const when = le.time_iso ? this._fmtDayShort(le.time_iso) + ', ' + this._fmtTime(le.time_iso) : '';
    let s = 'Your package is on its way.';
    if (place && when) s += ' Last scan: ' + place + ' — ' + when;
    else if (when) s += ' Last scan: ' + when;
    return s;
  }

  _render(info, shipment) {
    const status = shipment && shipment.latest_status ? shipment.latest_status.status : 'NotFound';
    const carrier = this._carrier(info);
    let h = '<div class="tot__dash">';

    // back link
    h += '<button type="button" class="tot__back" data-back>‹ Track another order</button>';

    // order header
    h += '<div>';
    h += '<h2 class="tot__order-no">Order ' + this._esc(info.order_no || info.no) + '</h2>';
    h += this._orderMeta(info, shipment);
    h += '</div>';

    // hero
    h += '<section class="tot__hero">';
    h += '<div class="tot__hero-main">';
    h += '<span class="tot__hero-badge">● ' + this._esc(this._statusLabel(status)) + '</span>';
    h += '<p class="tot__hero-title">' + this._esc(this._heroTitle(status, shipment)) + '</p>';
    h += '<p class="tot__hero-sub">' + this._esc(this._heroSub(status, shipment)) + '</p>';
    h += '</div>';
    h += '<div class="tot__hero-side">';
    h += '<p class="tot__hero-tnlabel">Tracking number</p>';
    if (this._isPlaceholderNo(info.no)) {
      h += '<p class="tot__hero-tn tot__hero-tn--pending">Not available yet</p>';
      h += '<p class="tot__hero-carrier">Carrier: ' + this._esc(carrier.name) + '</p>';
      h += '</div></section>';
    } else {
      h += '<p class="tot__hero-tn">' + this._esc(info.no) + '</p>';
      h += '<p class="tot__hero-carrier">Carrier: ' + this._esc(carrier.name) + '</p>';
      h += '<div class="tot__hero-actions">';
      h += '<button type="button" class="tot__hbtn" data-copy="' + this._esc(info.no) + '">Copy number</button>';
      h += '</div></div></section>';
    }

    // progress
    h += '<section class="tot__panel tot__panel--pad tot__progress">';
    h += '<p class="tot__panel-title tot__progress-title">Shipment progress</p>';
    h += this._stepper(status, shipment, info);
    h += '</section>';

    // columns
    h += '<div class="tot__cols"><div class="tot__col-main">';
    h += this._eventsPanel(shipment);
    h += this._noteCard();
    h += '</div><div class="tot__col-side">';
    h += this._eddCard(status, shipment);
    h += this._routeCard(info, shipment);
    h += this._shipmentCard(info);
    h += this._helpCard();
    h += '</div></div>';

    h += '</div>';

    const el = document.createElement('div');
    el.innerHTML = h;
    this.result.replaceChildren(el);
  }

  _orderMeta(info, shipment) {
    const bits = [];
    const placed = this._milestoneTime(shipment, 'InfoReceived');
    if (placed) bits.push('Placed ' + this._date(placed).toLocaleDateString(undefined, { month: 'long', day: 'numeric', year: 'numeric' }));
    const items = info.pinfos || [];
    if (items.length) {
      let name = this._clean(items[0].name) || '';
      if (items.length > 1) name += ' + ' + (items.length - 1) + ' more';
      if (name) bits.push(name);
      const qty = items.reduce((s, p) => s + (p.count || 1), 0);
      bits.push(qty + (qty === 1 ? ' Item' : ' Items'));
    }
    if (!bits.length) return '';
    return '<div class="tot__order-meta">' + bits.map((b) => '<span>' + this._esc(b) + '</span>').join('') + '</div>';
  }

  // Country of an event, from structured address or the trailing token of the
  // (Latin) location string. Empty when only foreign-language data is present.
  _eventCountry(ev) {
    const a = ev.address || {};
    if (a.country && !this._hasCJK(a.country)) return String(a.country).trim();
    const loc = ev.location ? String(ev.location).trim() : '';
    if (!loc || this._hasCJK(loc)) return '';
    const parts = loc.split(',').map((s) => s.trim()).filter(Boolean);
    return parts.length ? parts[parts.length - 1] : '';
  }
  // True when a country (code or name) matches the customer's destination country.
  _destMatch(country, dest) {
    if (!country || !dest) return false;
    country = String(country).trim();
    if (country.toUpperCase() === String(dest).toUpperCase()) return true;
    const name = this.COUNTRIES[dest];
    return !!name && country.toLowerCase() === name.toLowerCase();
  }
  _inDest(ev, dest) { return this._destMatch(this._eventCountry(ev), dest); }

  // Classify the dropship lifecycle into 6 stages and capture a timestamp each:
  //   0 Order Placed       — order info received
  //   1 In Production      — prep window between order received and the FIRST
  //                          logistics scan (no scan timestamp of its own)
  //   2 In Transit         — first scan by any logistics company (incl. origin leg)
  //   3 Arrived at Facility— arrived at a local facility in the customer's country
  //   4 Out for Delivery
  //   5 Delivered
  _stageInfo(status, shipment, info) {
    const dest = (info && info.destCountry) || '';
    const ms = {};
    ((shipment && shipment.milestone) || []).forEach((m) => { if (m.time_iso) ms[m.key_stage] = m.time_iso; });
    const provider = shipment && shipment.tracking && shipment.tracking.providers && shipment.tracking.providers[0];
    const events = (provider && provider.events) || [];
    const chrono = events.slice().reverse(); // events are newest-first
    const t = [null, null, null, null, null, null];
    const older = (a, b) => !b || new Date(a) < new Date(b);
    const prefix = (ev) => String(ev.sub_status || ev.stage || '').split('_')[0];

    t[0] = ms.InfoReceived || (chrono[0] && chrono[0].time_iso) || null;
    t[1] = null; // In Production is a phase, not a scan
    t[4] = ms.OutForDelivery || null;
    t[5] = ms.Delivered || (status === 'Delivered' && shipment && shipment.latest_event ? shipment.latest_event.time_iso : null);

    // 2 In Transit: the first scan by any logistics company.
    const firstScan = chrono.find((ev) => prefix(ev) !== 'InfoReceived');
    let t2 = ms.PickedUp || ms.Departure || null;
    if (firstScan && older(firstScan.time_iso, t2)) t2 = firstScan.time_iso;
    t[2] = t2;

    // 3 Arrived at Facility: a local arrival scan in the customer's country, after transit began.
    const destEvents = chrono.filter((ev) => this._inDest(ev, dest));
    const arrivals = destEvents.filter((ev) => {
      const c = ev.sub_status || '';
      const p = prefix(ev);
      return c === 'InTransit_Arrival' || c === 'InTransit_TransportArrived' || p === 'AvailableForPickup';
    });
    const local = arrivals.filter((ev) => !t[2] || new Date(ev.time_iso) > new Date(t[2]));
    if (local.length) t[3] = local[local.length - 1].time_iso;

    // Event-level fallbacks for the last two stages.
    if (!t[4]) { const ood = chrono.find((ev) => prefix(ev) === 'OutForDelivery'); if (ood) t[4] = ood.time_iso; }
    if (!t[5]) { const del = chrono.find((ev) => prefix(ev) === 'Delivered'); if (del) t[5] = del.time_iso; }

    let cur = 0;
    for (let i = 0; i < 6; i++) { if (t[i]) cur = i; }
    const floor = {
      InfoReceived: 1, InTransit: 2, AvailableForPickup: 3, OutForDelivery: 4,
      DeliveryFailure: 2, Exception: 2, Expired: 2, Delivered: 5, NotFound: 1,
    };
    if (floor[status] != null && floor[status] > cur) cur = floor[status];
    return { cur: cur, t: t };
  }

  _stepper(status, shipment, info) {
    const labels = [
      'Order Placed', 'In Production', 'In Transit',
      'Arrived at Facility', 'Out for Delivery', 'Delivered',
    ];
    const st = this._stageInfo(status, shipment, info);
    const cur = st.cur;
    const t = st.t;
    const delivered = status === 'Delivered';
    const edd = shipment && shipment.time_metrics && shipment.time_metrics.estimated_delivery_date;

    let h = '<ol class="tot__steps">';
    labels.forEach((label, i) => {
      if (i > 0) h += '<li class="tot__step-line' + (i <= cur ? ' is-done' : '') + '"></li>';
      const reached = i <= cur;
      const isCur = i === cur && !delivered;
      const state = reached ? (isCur ? 'current' : 'done') : 'pending';
      let date = '';
      if (t[i]) date = this._fmtStep(t[i]);
      else if (!reached) {
        date = (i === 5 && edd && (edd.to || edd.from))
          ? 'Est. ' + this._fmtDayShort(edd.to || edd.from) : '— pending —';
      }
      const mark = state === 'done' ? '✓' : (i + 1);
      h += '<li class="tot__step tot__step--' + state + '">';
      h += '<span class="tot__step-dot">' + mark + '</span>';
      h += '<span class="tot__step-label">' + label + '</span>';
      h += '<span class="tot__step-date">' + this._esc(date) + '</span>';
      h += '</li>';
    });
    h += '</ol>';
    return h;
  }

  _eventsPanel(shipment) {
    const provider = shipment && shipment.tracking && shipment.tracking.providers && shipment.tracking.providers[0];
    const events = (provider && provider.events) || [];
    const rows = [];
    events.forEach((ev) => {
      const desc = this._describe(ev);
      const place = this._place(ev);
      const prev = rows[rows.length - 1];
      if (prev && prev.desc === desc && prev.place === place) return;
      const pill = this._pill(ev);
      rows.push({ time: ev.time_iso, desc: desc, place: place, cat: pill.cat, pill: pill.label });
    });

    let h = '<section class="tot__panel">';
    h += '<div class="tot__panel-head"><span class="tot__panel-title">Tracking Events</span>';
    if (rows.length) h += '<span class="tot__panel-count">' + rows.length + (rows.length === 1 ? ' event' : ' events') + '</span>';
    h += '</div>';

    if (!rows.length) {
      h += '<div class="tot__empty">';
      h += '<p class="tot__empty-title">Your order is on its way.</p>';
      h += '<p class="tot__empty-desc">Detailed scan history isn’t available yet — it can take a few days for the carrier to report progress.</p>';
      h += '<p><a href="' + this._esc(this.fallback) + '">View full carrier tracking</a></p>';
      h += '</div></section>';
      return h;
    }

    h += '<ul class="tot__events">';
    rows.forEach((row, i) => {
      h += '<li class="tot__event">';
      h += '<span class="tot__event-rail"><span class="tot__event-dot' + (i === 0 ? ' is-current' : '') + '"></span><span class="tot__event-track"></span></span>';
      h += '<div class="tot__event-body">';
      h += '<div class="tot__event-head"><span class="tot__pill tot__pill--' + row.cat + '">' + this._esc(row.pill) + '</span>';
      h += '<span class="tot__event-title">' + this._esc(row.desc) + '</span></div>';
      const meta = [this._fmtFull(row.time)];
      if (row.place) meta.push(row.place);
      h += '<div class="tot__event-meta">' + this._esc(meta.join('  ·  ')) + '</div>';
      h += '</div></li>';
    });
    h += '</ul></section>';
    return h;
  }

  _noteCard() {
    const pills = [
      ['blue', 'Available for pickup'], ['amber', 'Delivery attempted'],
      ['red', 'Undelivered'], ['red', 'Exception'], ['grey', 'Expired'],
      ['amber', 'Returned to sender'],
    ];
    let h = '<aside class="tot__note">';
    h += '<div class="tot__note-head"><span class="tot__note-icon">⚠</span><span>What if my status changes?</span></div>';
    h += '<p class="tot__note-desc">We track every shipping state below. If your package enters one of these, we’ll update this page automatically.</p>';
    h += '<div class="tot__note-pills">';
    pills.forEach((p) => { h += '<span class="tot__pill tot__pill--' + p[0] + '">' + p[1] + '</span>'; });
    h += '</div></aside>';
    return h;
  }

  _eddCard(status, shipment) {
    const edd = shipment && shipment.time_metrics && shipment.time_metrics.estimated_delivery_date;
    let title, sub, flag, flagMuted = false;
    if (status === 'Delivered') {
      const t = this._milestoneTime(shipment, 'Delivered') || (shipment && shipment.latest_event && shipment.latest_event.time_iso);
      title = t ? this._fmtDay(t) : 'Delivered';
      sub = 'Arrived at destination';
      flag = 'Delivered';
    } else if (edd && (edd.to || edd.from)) {
      title = this._fmtDay(edd.to || edd.from);
      sub = (edd.from && edd.to && edd.from !== edd.to)
        ? 'Between ' + this._fmtDayShort(edd.from) + ' and ' + this._fmtDayShort(edd.to)
        : 'Estimated arrival';
      flag = 'On track for on-time delivery';
    } else {
      title = 'In transit';
      sub = 'We’ll estimate your delivery window once the carrier reports more detail.';
      flag = 'Tracking in progress';
      flagMuted = true;
    }
    let h = '<section class="tot__panel">';
    h += '<div class="tot__panel-head"><span class="tot__panel-title" style="font-size:14px">Estimated Delivery</span></div>';
    h += '<div class="tot__card-body">';
    h += '<p class="tot__edd-date">' + this._esc(title) + '</p>';
    h += '<p class="tot__edd-sub">' + this._esc(sub) + '</p>';
    h += '<hr class="tot__edd-rule">';
    h += '<div class="tot__edd-flag' + (flagMuted ? ' tot__edd-flag--muted' : '') + '"><span>●</span><span>' + this._esc(flag) + '</span></div>';
    h += '</div></section>';
    return h;
  }

  _routeCard(info, shipment) {
    const dest = (info && info.destCountry) || '';
    const ra = (shipment && shipment.shipping_info && shipment.shipping_info.recipient_address) || {};
    const toCity = ra.city && !this._hasCJK(ra.city) ? ra.city : '';
    const toCountry = this._country(ra.country || dest || '');

    // Only the facilities in the customer's country, in transit order. Origin
    // (China) scans are already hidden by _place, so they never appear here.
    const provider = shipment && shipment.tracking && shipment.tracking.providers && shipment.tracking.providers[0];
    const chrono = ((provider && provider.events) || []).slice().reverse();
    const seen = {};
    let stops = [];
    chrono.forEach((ev) => {
      if (!this._inDest(ev, dest)) return;
      const place = this._place(ev);
      if (!place || seen[place]) return;
      if (toCity && place.split(',')[0].trim() === toCity) return; // same as destination
      seen[place] = 1;
      stops.push(place);
    });
    if (stops.length > 6) stops = stops.slice(stops.length - 6); // keep the most recent legs

    let h = '<section class="tot__panel">';
    h += '<div class="tot__panel-head"><span class="tot__panel-title" style="font-size:14px">Route</span></div>';
    h += '<div class="tot__card-body"><div class="tot__route2">';

    // FROM — Residence Supply
    h += '<div class="tot__rstop tot__rstop--from">';
    h += '<span class="tot__rstop-rail"><span class="tot__rstop-dot"></span><span class="tot__rstop-track"></span></span>';
    h += '<div class="tot__rstop-body"><p class="tot__route-label">FROM</p>';
    h += '<p class="tot__route-name">' + this._esc(this.fromName) + '</p>';
    if (this.fromCity) h += '<p class="tot__route-line">' + this._esc(this.fromCity) + '</p>';
    if (this.fromCountry) h += '<p class="tot__route-line">' + this._esc(this.fromCountry) + '</p>';
    h += '</div></div>';

    // Intermediate destination-country facilities
    stops.forEach((place) => {
      h += '<div class="tot__rstop">';
      h += '<span class="tot__rstop-rail"><span class="tot__rstop-dot"></span><span class="tot__rstop-track"></span></span>';
      h += '<div class="tot__rstop-body"><p class="tot__route-line">' + this._esc(place) + '</p></div>';
      h += '</div>';
    });

    // TO — customer address (city + country)
    if (toCity || toCountry) {
      h += '<div class="tot__rstop tot__rstop--to">';
      h += '<span class="tot__rstop-rail"><span class="tot__rstop-dot"></span></span>';
      h += '<div class="tot__rstop-body"><p class="tot__route-label">TO</p>';
      if (toCity) h += '<p class="tot__route-name">' + this._esc(toCity) + '</p>';
      if (toCountry) h += '<p class="tot__route-line">' + this._esc(toCountry) + '</p>';
      h += '</div></div>';
    }

    h += '</div></div></section>';
    return h;
  }

  _shipmentCard(info) {
    const items = info.pinfos || [];
    if (!items.length) return '';
    let h = '<section class="tot__panel">';
    h += '<div class="tot__panel-head"><span class="tot__panel-title" style="font-size:14px">In this shipment</span></div>';
    h += '<div class="tot__card-body">';
    items.forEach((p) => {
      const name = this._clean(p.name) || 'Item';
      h += '<div class="tot__ship-item">';
      if (p.image_url) h += '<img class="tot__ship-thumb" src="' + this._esc(p.image_url) + '" alt="' + this._esc(name) + '" loading="lazy" width="56" height="56">';
      else h += '<span class="tot__ship-thumb"></span>';
      h += '<div><p class="tot__ship-name">' + this._esc(name) + '</p>';
      const meta = [];
      meta.push('Qty: ' + (p.count || 1));
      let price = (p.after_discount_price || p.unit_price || '').toString().trim();
      if (price && p.pc && price.slice(-p.pc.length) === p.pc) {
        price = price.slice(0, -p.pc.length).trim(); // drop duplicated currency suffix
      }
      if (price) meta.push(price);
      h += '<p class="tot__ship-meta">' + this._esc(meta.join('  ·  ')) + '</p>';
      h += '</div></div>';
    });
    h += '</div></section>';
    return h;
  }

  _helpCard() {
    let h = '<section class="tot__soft">';
    h += '<p class="tot__soft-title">Need help?</p>';
    h += '<p class="tot__soft-desc">Reach our customer service team if you don’t see updates after 48 hours.</p>';
    if (this.supportEmail) {
      h += '<a href="mailto:' + this._esc(this.supportEmail) + '">' + this._esc(this.supportEmail) + '</a>';
    }
    h += '</section>';
    return h;
  }

  _esc(s) {
    if (s == null) return '';
    return String(s).replace(/[&<>"']/g, (c) => ({
      '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;',
    }[c]));
  }
}
if (!customElements.get('track-order-test')) {
  customElements.define('track-order-test', TrackOrderTest);
}

  } catch(e) { console.error(e); }
})();
})();
